import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

interface TextProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
}

const Text: FC<TextProps> = props => {
  const { children, className = '', style } = props;

  return (
    <p style={style} className={twMerge(`px-3 text-base`, className)}>
      {children}
    </p>
  );
};

export default Text;
